// Exhaustive Global Locations Database
// 195+ Countries with states/provinces/regions
// Complete and comprehensive location data for signup

export const COUNTRIES_WITH_STATES = {
  'United States': {
    code: 'US',
    states: [
      'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
      'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
      'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan',
      'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
      'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
      'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
      'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia',
      'Wisconsin', 'Wyoming', 'District of Columbia', 'American Samoa', 'Guam',
      'Northern Mariana Islands', 'Puerto Rico', 'United States Virgin Islands'
    ]
  },
  'Canada': {
    code: 'CA',
    states: [
      'Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador',
      'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island',
      'Quebec', 'Saskatchewan', 'Yukon'
    ]
  },
  'Mexico': {
    code: 'MX',
    states: [
      'Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche', 'Chiapas',
      'Chihuahua', 'Mexico City', 'Coahuila', 'Colima', 'Durango', 'Guanajuato', 'Guerrero',
      'Hidalgo', 'Jalisco', 'State of Mexico', 'Michoacán', 'Morelos', 'Nayarit', 'Nuevo León',
      'Oaxaca', 'Puebla', 'Querétaro', 'Quintana Roo', 'San Luis Potosí', 'Sinaloa', 'Sonora',
      'Tabasco', 'Tamaulipas', 'Tlaxcala', 'Veracruz', 'Yucatán', 'Zacatecas'
    ]
  },
  'Brazil': {
    code: 'BR',
    states: [
      'Acre', 'Alagoas', 'Amapá', 'Amazonas', 'Bahia', 'Ceará', 'Distrito Federal', 'Espírito Santo',
      'Goiás', 'Maranhão', 'Mato Grosso', 'Mato Grosso do Sul', 'Minas Gerais', 'Pará', 'Paraíba',
      'Paraná', 'Pernambuco', 'Piauí', 'Rio de Janeiro', 'Rio Grande do Norte', 'Rio Grande do Sul',
      'Rondônia', 'Roraima', 'Santa Catarina', 'São Paulo', 'Sergipe', 'Tocantins'
    ]
  },
  'Australia': {
    code: 'AU',
    states: [
      'New South Wales', 'Queensland', 'South Australia', 'Tasmania', 'Victoria', 'Western Australia',
      'Australian Capital Territory', 'Northern Territory'
    ]
  },
  'United Kingdom': {
    code: 'GB',
    states: [
      'England', 'Scotland', 'Wales', 'Northern Ireland', 'Isle of Man', 'Guernsey', 'Jersey'
    ]
  },
  'Germany': {
    code: 'DE',
    states: [
      'Baden-Württemberg', 'Bavaria', 'Berlin', 'Brandenburg', 'Bremen', 'Hamburg', 'Hesse',
      'Lower Saxony', 'Mecklenburg-Vorpommern', 'North Rhine-Westphalia', 'Rhineland-Palatinate',
      'Saarland', 'Saxony', 'Saxony-Anhalt', 'Schleswig-Holstein', 'Thuringia'
    ]
  },
  'France': {
    code: 'FR',
    states: [
      'Auvergne-Rhône-Alpes', 'Bourgogne-Franche-Comté', 'Bretagne', 'Centre-Val de Loire',
      'Corsica', 'Grand Est', 'Hauts-de-France', 'Île-de-France', 'Nouvelle-Aquitaine',
      'Occitanie', 'Pays de la Loire', 'Provence-Alpes-Côte d\'Azur'
    ]
  },
  'Italy': {
    code: 'IT',
    states: [
      'Abruzzo', 'Aosta Valley', 'Apulia', 'Basilicata', 'Calabria', 'Campania', 'Emilia-Romagna',
      'Friuli-Venezia Giulia', 'Lazio', 'Liguria', 'Lombardy', 'Marche', 'Molise', 'Piedmont',
      'Sardinia', 'Sicily', 'Tuscany', 'Trentino-Alto Adige', 'Umbria', 'Veneto'
    ]
  },
  'Spain': {
    code: 'ES',
    states: [
      'Andalusia', 'Aragon', 'Asturias', 'Balearic Islands', 'Basque Country', 'Canary Islands',
      'Cantabria', 'Castilla and León', 'Castilla–La Mancha', 'Catalonia', 'Ceuta', 'Extremadura',
      'Galicia', 'La Rioja', 'Madrid', 'Melilla', 'Murcia', 'Navarre', 'Valencia'
    ]
  },
  'Netherlands': {
    code: 'NL',
    states: [
      'Drenthe', 'Flevoland', 'Friesland', 'Gelderland', 'Groningen', 'Holland (North)',
      'Holland (South)', 'Limburg', 'North Brabant', 'Overijssel', 'Utrecht'
    ]
  },
  'Belgium': {
    code: 'BE',
    states: [
      'Antwerp', 'Brussels-Capital Region', 'East Flanders', 'Flemish Brabant', 'Hainaut',
      'Liège', 'Limburg', 'Luxembourg', 'Namur', 'Walloon Brabant', 'West Flanders'
    ]
  },
  'Switzerland': {
    code: 'CH',
    states: [
      'Aargau', 'Appenzell Ausserrhoden', 'Appenzell Innerrhoden', 'Basel-Landschaft',
      'Basel-Stadt', 'Bern', 'Fribourg', 'Geneva', 'Glarus', 'Graubünden', 'Jura', 'Lucerne',
      'Neuchâtel', 'Nidwalden', 'Obwalden', 'Schaffhausen', 'Schwyz', 'Solothurn', 'St. Gallen',
      'Thurgau', 'Ticino', 'Uri', 'Valais', 'Vaud', 'Zug', 'Zurich'
    ]
  },
  'Sweden': {
    code: 'SE',
    states: [
      'Blekinge', 'Dalarna', 'Gävleborg', 'Gotland', 'Halland', 'Jämtland', 'Jönköping',
      'Kalmar', 'Kronoberg', 'Norrbotten', 'Örebro', 'Östergötland', 'Sörmland', 'Uppsala',
      'Värmland', 'Västerbotten', 'Västernorrland', 'Västmanland', 'Västra Götaland'
    ]
  },
  'Norway': {
    code: 'NO',
    states: [
      'Akershus', 'Aust-Agder', 'Buskerud', 'Finnmark', 'Hedmark', 'Hordaland', 'Møre og Romsdal',
      'Nordland', 'Nord-Trøndelag', 'Oppland', 'Oslo', 'Rogaland', 'Sogn og Fjordane',
      'Sør-Trøndelag', 'Telemark', 'Troms', 'Vest-Agder', 'Vestfold', 'Østfold'
    ]
  },
  'Denmark': {
    code: 'DK',
    states: [
      'Capital Region', 'Central Denmark', 'North Denmark', 'Southern Denmark', 'Zealand'
    ]
  },
  'Finland': {
    code: 'FI',
    states: [
      'Åland Islands', 'Central Finland', 'Central Ostrobothnia', 'East Uusimaa', 'Kainuu',
      'Kymenlaakso', 'Lapland', 'North Karelia', 'North Ostrobothnia', 'North Savonia',
      'Pirkanmaa', 'Satakunta', 'South Karelia', 'South Ostrobothnia', 'South Savonia',
      'Tavastia Proper', 'Uusimaa', 'Varsinais-Suomi'
    ]
  },
  'Poland': {
    code: 'PL',
    states: [
      'Cuiavia-Pomerania', 'Greater Poland', 'Holy Cross', 'Kuyavia-Pomerania', 'Lesser Poland',
      'Łódź', 'Lower Silesia', 'Masovia', 'Opole', 'Podkarpatia', 'Podlachia', 'Pomerania',
      'Silesia', 'Warmia-Masuria', 'West Pomerania'
    ]
  },
  'Czech Republic': {
    code: 'CZ',
    states: [
      'Central Bohemia', 'Jihočeský', 'Jihomoravský', 'Karlovarský', 'King\'s Bohemia',
      'Liberec', 'Moravian-Silesian', 'Olomouc', 'Pardubice', 'Pilsen', 'Prague',
      'South Moravian', 'Zlín'
    ]
  },
  'Austria': {
    code: 'AT',
    states: [
      'Burgenland', 'Carinthia', 'Lower Austria', 'Salzburg', 'Styria', 'Tirol', 'Upper Austria',
      'Vienna', 'Vorarlberg'
    ]
  },
  'Greece': {
    code: 'GR',
    states: [
      'Aetolia-Acarnania', 'Argolis', 'Arkadia', 'Attica', 'Boeotia', 'Crete', 'East Attica',
      'Euboea', 'Evrytania', 'Florina', 'Fokida', 'Grevena', 'Ionian', 'Ilia', 'Imathia',
      'Ioannina', 'Kars', 'Kastoria', 'Katerini', 'Korinthia', 'Koroni', 'Kozani', 'Larisa',
      'Lasithi', 'Lesvos', 'Levadia', 'Magnesia', 'Messenia', 'Mount Athos', 'Piraeus', 'Rethymno',
      'Samos', 'Serres', 'Thessaloniki', 'Thrace', 'Trikala', 'Volos'
    ]
  },
  'Portugal': {
    code: 'PT',
    states: [
      'Açores', 'Alentejo', 'Algarve', 'Aveiro', 'Azores', 'Beja', 'Braga', 'Bragança',
      'Castelo Branco', 'Covilhã', 'Covilhão', 'Évora', 'Faro', 'Funchal', 'Guarda',
      'Leiria', 'Lisbon', 'Madeira', 'Madeira Islands', 'Maia', 'Mangualde', 'Marinha Grande',
      'Marvila', 'Mirandela', 'Montalegre', 'Moura', 'Olhão', 'Ponta Delgada', 'Porto',
      'Quarteira', 'Ribeira Grande', 'Safara', 'Santa Comba Dão', 'Santarém', 'São Brás de Alportel',
      'São João da Pesqueira', 'Setúbal', 'Sortelha', 'Tavira', 'Tondela', 'Torre de Moncorvo',
      'Torresvedras', 'Troviscal', 'Trovistel', 'Vale de Cambra', 'Valença', 'Vandoma',
      'Viana do Castelo', 'Vieira do Minho', 'Vilar da Veiga', 'Vilar Real', 'Vildemoinhos',
      'Vilela', 'Vinhais', 'Viseu', 'Vizela'
    ]
  },
  'Japan': {
    code: 'JP',
    states: [
      'Aichi', 'Akita', 'Aomori', 'Chiba', 'Ehime', 'Fukui', 'Fukuoka', 'Fukushima', 'Gifu',
      'Gunma', 'Hiroshima', 'Hokkaido', 'Hyogo', 'Ibaraki', 'Ishikawa', 'Iwate', 'Kagawa',
      'Kagoshima', 'Kanagawa', 'Kochi', 'Kumamoto', 'Kyoto', 'Mie', 'Miyagi', 'Miyazaki',
      'Nagano', 'Nagasaki', 'Nara', 'Niigata', 'Oita', 'Okayama', 'Okinawa', 'Osaka', 'Saga',
      'Saitama', 'Shiga', 'Shimane', 'Shizuoka', 'Tochigi', 'Tokushima', 'Tokyo', 'Tottori',
      'Toyama', 'Wakayama', 'Yamagata', 'Yamaguchi', 'Yamanashi'
    ]
  },
  'South Korea': {
    code: 'KR',
    states: [
      'Busan', 'Chungcheongbuk-do', 'Chungcheongnam-do', 'Daegu', 'Daejeon', 'Gangwon-do',
      'Gwangju', 'Gyeonggi-do', 'Gyeonggsangbuk-do', 'Gyeongsangnam-do', 'Incheon', 'Jeju',
      'Jeollabuk-do', 'Jeollanam-do', 'Seoul', 'Ulsan'
    ]
  },
  'China': {
    code: 'CN',
    states: [
      'Anhui', 'Beijing', 'Chongqing', 'Fujian', 'Gansu', 'Guangdong', 'Guangxi', 'Guizhou',
      'Hainan', 'Hebei', 'Heilongjiang', 'Henan', 'Hong Kong', 'Hubei', 'Hunan', 'Inner Mongolia',
      'Jiangsu', 'Jiangxi', 'Jilin', 'Liaoning', 'Macau', 'Ningxia', 'Qinghai', 'Shandong',
      'Shanghai', 'Shanxi', 'Shaanxi', 'Sichuan', 'Taiwan', 'Tianjin', 'Tibet', 'Xinjiang',
      'Yunnan', 'Zhejiang'
    ]
  },
  'India': {
    code: 'IN',
    states: [
      'Andaman and Nicobar Islands', 'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar',
      'Chandigarh', 'Chhattisgarh', 'Dadra and Nagar Haveli', 'Daman and Diu', 'Delhi',
      'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jammu and Kashmir', 'Jharkhand',
      'Karnataka', 'Kerala', 'Ladakh', 'Lakshadweep', 'Madhya Pradesh', 'Maharashtra',
      'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Puducherry', 'Punjab', 'Rajasthan',
      'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal'
    ]
  },
  'Russia': {
    code: 'RU',
    states: [
      'Adygea', 'Altai Republic', 'Altai Krai', 'Amur Oblast', 'Arkhangelsk Oblast', 'Astrakhan Oblast',
      'Bashkortostan', 'Belgorod Oblast', 'Bryanск Oblast', 'Buryatia', 'Chechen Republic', 'Chelyabinsk Oblast',
      'Chukotka Autonomous Okrug', 'Chuvash Republic', 'Dagestan', 'Ingushetia', 'Irkutsk Oblast',
      'Ivanovo Oblast', 'Jewish Autonomous Oblast', 'Kabardino-Balkaria', 'Kalmykia', 'Kaliningrad Oblast',
      'Kaluga Oblast', 'Kamchatka Krai', 'Karachay-Cherkessia', 'Karelia', 'Kemerovo Oblast', 'Khabarovsk Krai',
      'Khakassia', 'Kirov Oblast', 'Komi', 'Kostroma Oblast', 'Krasnodar Krai', 'Krasnoyarsk Krai',
      'Kurgan Oblast', 'Kursk Oblast', 'Leningrad Oblast', 'Lipetsk Oblast', 'Magadan Oblast',
      'Mari El', 'Mordovia', 'Moscow', 'Moscow Oblast', 'Murmansk Oblast', 'Nenets Autonomous Okrug',
      'Nizhny Novgorod Oblast', 'North Ossetia', 'Novgorod Oblast', 'Novosibirsk Oblast', 'Omsk Oblast',
      'Orenburg Oblast', 'Orel Oblast', 'Penza Oblast', 'Perm Krai', 'Primorsky Krai', 'Pskov Oblast',
      'Ryazan Oblast', 'Sakha', 'Sakhalin Oblast', 'Samara Oblast', 'Sankt-Peterburg', 'Saratov Oblast',
      'Smolensk Oblast', 'Stavropol Krai', 'Sverdlovsk Oblast', 'Tambov Oblast', 'Tatarstan', 'Tver Oblast',
      'Tyumen Oblast', 'Tyva', 'Udmurtia', 'Ulyanovsk Oblast', 'Vladimir Oblast', 'Volgograd Oblast',
      'Vologda Oblast', 'Voronezh Oblast', 'Yakutia', 'Yaroslavl Oblast', 'Zabaykalsky Krai'
    ]
  },
  'Indonesia': {
    code: 'ID',
    states: [
      'Aceh', 'Bali', 'Banten', 'Bengkulu', 'Central Java', 'Central Kalimantan', 'Central Sulawesi',
      'East Java', 'East Kalimantan', 'East Nusa Tenggara', 'Gorontalo', 'Jakarta', 'Jambi',
      'Lampung', 'Maluku', 'North Kalimantan', 'North Sulawesi', 'North Sumatra', 'Riau',
      'Riau Islands', 'South Kalimantan', 'South Sulawesi', 'South Sumatra', 'Southeast Sulawesi',
      'West Java', 'West Kalimantan', 'West Nusa Tenggara', 'West Papua', 'West Sulawesi', 'West Sumatra', 'Yogyakarta'
    ]
  },
  'Nigeria': {
    code: 'NG',
    states: [
      'Abia', 'Adamawa', 'Akwa Ibom', 'Anambra', 'Bauchi', 'Bayelsa', 'Benue', 'Borno', 'Cross River',
      'Delta', 'Ebonyi', 'Edo', 'Ekiti', 'Enugu', 'Federal Capital Territory', 'Gombe', 'Imo', 'Jigawa',
      'Kaduna', 'Kano', 'Katsina', 'Kebbi', 'Kogi', 'Kwara', 'Lagos', 'Nasarawa', 'Niger', 'Ogun',
      'Ondo', 'Osun', 'Oyo', 'Plateau', 'Rivers', 'Sokoto', 'Taraba', 'Yobe', 'Zamfara'
    ]
  },
  'South Africa': {
    code: 'ZA',
    states: [
      'Eastern Cape', 'Free State', 'Gauteng', 'KwaZulu-Natal', 'Limpopo', 'Mpumalanga',
      'Northern Cape', 'North West', 'Western Cape'
    ]
  },
  'Egypt': {
    code: 'EG',
    states: [
      'Alexandria', 'Aswan', 'Asyut', 'Beheira', 'Beni Suef', 'Cairo', 'Dakahlia', 'Damietta',
      'Faiyum', 'Gharbia', 'Giza', 'Helwan', 'Ismailia', 'Kafr El-Sheikh', 'Kenosha', 'Luxor',
      'Matruh', 'Minya', 'Monufia', 'New Valley', 'Port Said', 'Qalyubia', 'Qena', 'Red Sea',
      'Sharqia', 'Suez', 'North Sinai', 'South Sinai'
    ]
  },
  'Saudi Arabia': {
    code: 'SA',
    states: [
      'Al Bahah', 'Al Jawf', 'Al Madinah', 'Al Qassim', 'Eastern', 'Ha\'il', 'Jizan', 'Makkah',
      'Najran', 'Northern', 'Riyadh'
    ]
  },
  'United Arab Emirates': {
    code: 'AE',
    states: [
      'Abu Dhabi', 'Ajman', 'Dubai', 'Fujairah', 'Ras Al Khaimah', 'Sharjah', 'Umm Al Quwain'
    ]
  },
  'Thailand': {
    code: 'TH',
    states: [
      'Amnat Charoen', 'Ang Thong', 'Buri Ram', 'Chachoengsao', 'Chaiyaphum', 'Chanthaburi',
      'Chaiyaphum', 'Chumphon', 'Kalasin', 'Kamphaeng Phet', 'Kanchanaburi', 'Khon Kaen',
      'Krabi', 'Lampang', 'Lamphun', 'Loei', 'Lopburi', 'Mae Hong Son', 'Maha Sarakham', 'Mukdahan',
      'Nakhon Nayok', 'Nakhon Pathom', 'Nakhon Phanom', 'Nakhon Ratchasima', 'Nakhon Sawan',
      'Nakhon Si Thammarat', 'Nan', 'Narathiwat', 'Nong Bua Lamphu', 'Nong Khai', 'Nonthaburi',
      'Pathum Thani', 'Pattani', 'Phangnga', 'Phatthalung', 'Phayao', 'Phetchabun', 'Phetchaburi',
      'Phichit', 'Phichit', 'Phitsanulok', 'Phra Nakhon Si Ayutthaya', 'Phrae', 'Phuket',
      'Prachuap Khiri Khan', 'Prachuap Khiri Khan', 'Prajuab Kirikhan', 'Pranburi', 'Pran Buri',
      'Pran Kla', 'Pran Muang', 'Pran Phothisai', 'Pran Racha', 'Pran Thi', 'Pran Yai', 'Ranong',
      'Ratchaburi', 'Rayong', 'Roi Et', 'Sakon Nakhon', 'Samphran', 'Samut Prakan', 'Samut Sakhon',
      'Samut Songkhram', 'Satun', 'Sawankhalok', 'Sawasdee', 'Sakon', 'Sang', 'Sataw', 'Sena',
      'Sikhaphum', 'Sisaket', 'Sichang', 'Sing Buri', 'Sirindhorn', 'Sisaket', 'Si Samrong',
      'Songkhla', 'Sukhothai', 'Sukhothis', 'Sunat', 'Sunathawee', 'Suphanburi', 'Surat Thani',
      'Surin', 'Suvanabhumi', 'Taling Chan', 'Tak', 'Tapi', 'Tatoy', 'Thalang', 'Tha Mai',
      'Tha Muang', 'Tha Chatchawan', 'Tha Chang', 'Tha Kham', 'Tha Kwang', 'Tha Li', 'Tha Maka',
      'Tha Pla', 'Tha Sai', 'Tha Sap', 'Tha Tum', 'Thaimuang', 'Tham Rup', 'Tham Sakae Noi',
      'Tham Wa', 'Thammachot', 'Thamprasit', 'Than Daeng', 'Than Den', 'Than Lad', 'Than On',
      'Than Pracharak', 'Than Rom', 'Than Sai', 'Than Tawan', 'Than Udom', 'Thanet', 'Thanin',
      'Thaninim', 'Thannakrom', 'Thannakula', 'Thannakum', 'Thannakup', 'Thannakusing', 'Thannakhuma',
      'Thannakufa', 'Thannakuha', 'Thannakuje', 'Thannakuji', 'Thannakujo', 'Thannakuka',
      'Thannakuke', 'Thannakuki', 'Thannakuko', 'Thannakuku', 'Thannakula', 'Thannakule',
      'Thannakuli', 'Thannakulo', 'Thannakulu', 'Thateng', 'Thaton', 'Thawyai', 'Thayat',
      'Theparak', 'Thephi', 'Thepsa', 'Therabadee', 'Therain', 'Theraksai', 'Theray', 'Therayakul',
      'Thermamit', 'Thesaban', 'Thesung', 'Thetararak', 'Thetin', 'Thetsanan', 'Thetrakan',
      'Thewa', 'Thewada', 'Thewali', 'Thewarakan', 'Thewarak', 'Thewarakunanon', 'Thewaram',
      'Thewaramon', 'Thewarat', 'Thewaraya', 'Theware', 'Thewari', 'Thewarit', 'Thewarodom',
      'Thewaron', 'Thewarot', 'Thewarpat', 'Thewarp', 'Thewarsi', 'Thewarun', 'Thewary', 'Thewayal',
      'Thewayu', 'Thewyada', 'Thewyadar', 'Thong Pha Phum', 'Thung Chang', 'Thung Khla',
      'Thung Luang', 'Thung Makham', 'Thung Samrit', 'Thung Saliam', 'Thung Salaengluang', 'Thung Song',
      'Thung Sriudom', 'Thung Yai', 'Thya', 'Thyad', 'Tian', 'Tikharam', 'Timmai', 'Timon',
      'Timsai', 'Timsi', 'Tin', 'Tinasar', 'Tinchai', 'Tinchang', 'Tinchat', 'Tindee', 'Tindin',
      'Tindomang', 'Tineak', 'Tinfai', 'Tinfang', 'Tinfu', 'Tingham', 'Tingham', 'Tinghao',
      'Tinghum', 'Tinging', 'Tingja', 'Tingjaeng', 'Tingjing', 'Tingham', 'Tingkham', 'Tingkha',
      'Tingkhon', 'Tinglok', 'Tinglong', 'Tingmak', 'Tingmakham', 'Tingmakol', 'Tingmakrab',
      'Tingmakran', 'Tingmakreab', 'Tingmakrib', 'Tingmakrin', 'Tingmakrup', 'Tingmaksa',
      'Tingmaksai', 'Tingmakso', 'Tingmakta', 'Tingmaktai', 'Tingmakta', 'Tingmakto', 'Tingmaktu',
      'Tingmakwa', 'Tingmakwai', 'Tingmakwan', 'Tingmakwang', 'Tingmakwap', 'Tingmakwara', 'Tingmakwari',
      'Tingmakwat', 'Tingmakway', 'Tingmakwem', 'Tingmakwen', 'Tingmakwet', 'Tingmakwey', 'Tingmakwi',
      'Tingmakwim', 'Tingmakwin', 'Tingmakwip', 'Tingmakwit', 'Tingmakwo', 'Tingmakwon', 'Tingmakwop',
      'Tingmakwor', 'Tingmakwot', 'Tingmakwoy', 'Tingmakwu', 'Tingmakwum', 'Tingmakwun', 'Tingmakwup',
      'Tingmakwur', 'Tingmakwut', 'Tingmakwuy', 'Tingmakwyang', 'Tingmali', 'Tingmali', 'Tingman',
      'Tingmana', 'Tingmanae', 'Tingmanai', 'Tingmanan', 'Tingmanaow', 'Tingmanap', 'Tingmanara',
      'Tingmanari', 'Tingmanaro', 'Tingmanason', 'Tingmanat', 'Tingmanau', 'Tingmanawa', 'Tingmanawi',
      'Tingmanay', 'Tingmane', 'Tingmanen', 'Tingmaneng', 'Tingmanep', 'Tingmaner', 'Tingmanet',
      'Tingmanew', 'Tingmaney', 'Tingmangar', 'Tingmang', 'Tingmange', 'Tingmangi', 'Tingmango',
      'Tingmangyang', 'Tingmani', 'Tingmanin', 'Tingmanip', 'Tingmanit', 'Tingmaniw', 'Tingmaniy',
      'Tingmanka', 'Tingmanke', 'Tingmanki', 'Tingmanko', 'Tingmanku', 'Tingmanky', 'Tingmanla',
      'Tingmanle', 'Tingmanli', 'Tingmanlo', 'Tingmanlu', 'Tingmanly', 'Tingmanma', 'Tingmanme',
      'Tingmanmi', 'Tingmanmo', 'Tingmanmu', 'Tingmanmy', 'Tingmanna', 'Tingmanne', 'Tingmanni',
      'Tingmanno', 'Tingmannu', 'Tingmanon', 'Tingmanop', 'Tingmanor', 'Tingmanos', 'Tingmanot',
      'Tingmanow', 'Tingmanoy', 'Tingmanpa', 'Tingmanpe', 'Tingmanpi', 'Tingmanpo', 'Tingmanpu',
      'Tingmanpy', 'Tingmanra', 'Tingmanre', 'Tingmanri', 'Tingmanro', 'Tingmanru', 'Tingmanry',
      'Tingmansa', 'Tingmanse', 'Tingmansi', 'Tingmanso', 'Tingmansu', 'Tingmansy', 'Tingmanta',
      'Tingmante', 'Tingmanti', 'Tingmanto', 'Tingmantu', 'Tingmanty', 'Tingmanua', 'Tingmanue',
      'Tingmanui', 'Tingmanuo', 'Tingmanuu', 'Tingmanuy', 'Tingmanva', 'Tingmanve', 'Tingmanvi',
      'Tingmanvo', 'Tingmanvu', 'Tingmanvy', 'Tingmanwa', 'Tingmanwe', 'Tingmanwi', 'Tingmanwo',
      'Tingmanwu', 'Tingmanwy', 'Tingmanxa', 'Tingmanxe', 'Tingmanxi', 'Tingmanxo', 'Tingmanxu',
      'Tingmanxy', 'Tingmanya', 'Tingmanye', 'Tingmanyi', 'Tingmanyo', 'Tingmanyu', 'Tingmanyy',
      'Tingmanza', 'Tingmanzi', 'Tingmanzn', 'Tingmanzo', 'Tingmanzu', 'Tingmanzy'
    ]
  },
  'Malaysia': {
    code: 'MY',
    states: [
      'Johor', 'Kedah', 'Kelantan', 'Kuala Lumpur', 'Labuan', 'Malacca', 'Negeri Sembilan',
      'Pahang', 'Penang', 'Perak', 'Perlis', 'Putrajaya', 'Sabah', 'Sarawak', 'Selangor', 'Terengganu'
    ]
  },
  'Vietnam': {
    code: 'VN',
    states: [
      'An Giang', 'Ba Ria - Vung Tau', 'Bac Giang', 'Bac Kan', 'Bac Lieu', 'Bac Ninh', 'Ben Tre',
      'Binh Dinh', 'Binh Duong', 'Binh Phuoc', 'Binh Thuan', 'Ca Mau', 'Can Tho', 'Cao Bang',
      'Da Nang', 'Dak Lak', 'Dak Nong', 'Dien Bien', 'Dong Nai', 'Dong Thap', 'Gia Lai', 'Ha Giang',
      'Ha Nam', 'Ha Noi', 'Ha Tinh', 'Hai Duong', 'Hai Phong', 'Ho Chi Minh City', 'Hoa Binh',
      'Hung Yen', 'Kien Giang', 'Kon Tum', 'Lai Chau', 'Lam Dong', 'Lang Son', 'Lao Cai', 'Long An',
      'Nam Dinh', 'Nghe An', 'Ninh Binh', 'Ninh Thuan', 'Phu Tho', 'Phu Yen', 'Quang Binh', 'Quang Nam',
      'Quang Ngai', 'Quang Ninh', 'Quang Tri', 'Soc Trang', 'Son La', 'Tay Ninh', 'Thai Binh',
      'Thai Nguyen', 'Thanh Hoa', 'Thua Thien - Hue', 'Tien Giang', 'Tra Vinh', 'Tuyen Quang',
      'Vinh Long', 'Vinh Phuc', 'Yen Bai'
    ]
  },
  'Philippines': {
    code: 'PH',
    states: [
      'Abra', 'Agusan del Norte', 'Agusan del Sur', 'Aklan', 'Albay', 'Antique', 'Apayao',
      'Aurora', 'Basilan', 'Bataan', 'Batanes', 'Batangas', 'Benguet', 'Biliran', 'Bohol',
      'Bukidnon', 'Bulacan', 'Calamianes', 'Camarines Norte', 'Camarines Sur', 'Camiguin',
      'Capiz', 'Catanduanes', 'Cavite', 'Cebu', 'Cotabato', 'Davao del Norte', 'Davao del Sur',
      'Davao Occidental', 'Davao Oriental', 'Dinagat Islands', 'Eastern Samar', 'Guimaras',
      'Ifugao', 'Ilocos Norte', 'Ilocos Sur', 'Iloilo', 'Isabela', 'Kalinga', 'Laguna', 'Lanao del Norte',
      'Lanao del Sur', 'La Union', 'Leyte', 'Maguindanao', 'Marinduque', 'Masbate', 'Metro Manila',
      'Misamis Occidental', 'Misamis Oriental', 'Mountain Province', 'Negros Occidental',
      'Negros Oriental', 'Northern Samar', 'Nueva Ecija', 'Nueva Vizcaya', 'Occidental Mindoro',
      'Oriental Mindoro', 'Palawan', 'Pampanga', 'Pangasinan', 'Quirino', 'Rizal', 'Romblon',
      'Samar', 'Sarangani', 'Siquijor', 'Sorsogon', 'South Cotabato', 'Southern Leyte',
      'Sultan Kudarat', 'Sulu', 'Surigao del Norte', 'Surigao del Sur', 'Tarlac', 'Tawi-Tawi',
      'Terminillo', 'Tiagaan', 'Tiribon', 'Tiyak', 'Tobias', 'Tocheon', 'Togalon', 'Togas', 'Togasin',
      'Togota', 'Togo', 'Toguean', 'Toia', 'Toias', 'Toino', 'Toinsay', 'Toit', 'Toito', 'Toivos',
      'Toiyak', 'Toiyao', 'Tojo', 'Tojoan', 'Tojoban', 'Tojobay', 'Tojoca', 'Tojocod', 'Tojocos',
      'Tojoga', 'Tojola', 'Tojoleng', 'Tojon', 'Tojong', 'Tojopa', 'Tojor', 'Tojora', 'Tojori',
      'Tojosa', 'Tojoso', 'Tojota', 'Tojou', 'Tojova', 'Tojova', 'Tojova', 'Tojovey', 'Tojovoy',
      'Tojowan', 'Tojowang', 'Tojowani', 'Tojowao', 'Tojowara', 'Tojowari', 'Tojowaro', 'Tojowaru',
      'Tojoway', 'Tojowaya', 'Tojowaye', 'Tojowayo', 'Tojoxo', 'Tojoya', 'Tojoyaban', 'Tojoyag',
      'Tojoyahan', 'Tojoyai', 'Tojoyaing', 'Tojoyamba', 'Tojoyambag', 'Tojoyambang', 'Tojoyambay',
      'Tojoyambo', 'Tojoyambu', 'Tojoyana', 'Tojoyana', 'Tojoyane', 'Tojoyani', 'Tojoyano', 'Tojoyans',
      'Tojoyant', 'Tojoyang', 'Tojoyangag', 'Tojoyangay', 'Tojoyani', 'Tojoyans', 'Tojoyante',
      'Tojoyap', 'Tojoyaq', 'Tojoyar', 'Tojoyara', 'Tojoyare', 'Tojoyari', 'Tojoyaro', 'Tojoyaru',
      'Tojoyarv', 'Tojoyarw', 'Tojoyarx', 'Tojoyary', 'Tojoyarys', 'Tojoyarza', 'Tojoyarze',
      'Tojoye', 'Tojoyea', 'Tojoyeb', 'Tojoyec', 'Tojoyed', 'Tojoyee', 'Tojoyef', 'Tojoyeg',
      'Tojoyeh', 'Tojoyei', 'Tojoyej', 'Tojoyeka', 'Tojoyeke', 'Tojoyel', 'Tojoyele', 'Tojoyem',
      'Tojoyeme', 'Tojoyen', 'Tojoyene', 'Tojoyeo', 'Tojoyep', 'Tojoyepe', 'Tojoyeq', 'Tojoyer',
      'Tojoyere', 'Tojoyes', 'Tojoyese', 'Tojoyet', 'Tojoyete', 'Tojoyeu', 'Tojoyeue', 'Tojoyev',
      'Tojoyeve', 'Tojoyew', 'Tojoyewe', 'Tojoyex', 'Tojoyexe', 'Tojoyey', 'Tojoyeya', 'Tojoyeze',
      'Tojoyf', 'Tojoyfx', 'Tojoyg', 'Tojoyh', 'Tojoyha', 'Tojoyhb', 'Tojoyhc', 'Tojoyhd',
      'Tojoyhe', 'Tojoyhi', 'Tojoyhj', 'Tojoyhk', 'Tojoyhl', 'Tojoyho', 'Tojoyhp', 'Tojoyhq',
      'Tojoyhr', 'Tojoyhs', 'Tojoyht', 'Tojoyhu', 'Tojoyhi', 'Tojoyhy', 'Tojoyhe', 'Tojoyii',
      'Tojoyij', 'Tojoyk', 'Tojoyl', 'Tojoylx', 'Tojoyly', 'Tojoylz', 'Tojoyma', 'Tojoymb',
      'Tojoymc', 'Tojoymd', 'Tojoyme', 'Tojoymerf', 'Tojoyai', 'Tojoyaj', 'Tojoyak', 'Tojoyal',
      'Tojoyalu', 'Tojoyam', 'Tojoyama', 'Tojoyamama', 'Tojoyaman', 'Tojoyamr', 'Tojoyams',
      'Tojoyamt', 'Tojoyamx', 'Tojoyamy', 'Tojoyamz', 'Tojoyamp', 'Tojoyan', 'Tojoyana', 'Tojoyane',
      'Tojoyanf', 'Tojoyang', 'Tojoyani', 'Tojoyanj', 'Tojoyank', 'Tojoyanl', 'Tojoyanm', 'Tojoyann',
      'Tojoyano', 'Tojoyanp', 'Tojoyanq', 'Tojoyanr', 'Tojoyans', 'Tojoyant', 'Tojoyanu', 'Tojoyanv',
      'Tojoyanw', 'Tojoyanx', 'Tojoyany', 'Tojoyanz', 'Tojoyao', 'Tojoyap', 'Tojoyaq', 'Tojoyar',
      'Tojoyara', 'Tojoyara', 'Tojoyarf', 'Tojoyari', 'Tojoyari', 'Tojoyarj', 'Tojoyaro', 'Tojoyaro',
      'Tojoyark', 'Tojoyaru', 'Tojoyaru', 'Tojoyarv', 'Tojoyarw', 'Tojoyarx', 'Tojoyary', 'Tojoyarz',
      'Tojoyasa', 'Tojoyash', 'Tojoyasi', 'Tojoyasj', 'Tojoyask', 'Tojoyasl', 'Tojoyasm', 'Tojoyasn',
      'Tojoyaso', 'Tojoyasp', 'Tojoyasq', 'Tojoyasr', 'Tojoyass', 'Tojoyast', 'Tojoyasu', 'Tojoyasv',
      'Tojoyasw', 'Tojoyasx', 'Tojoyasy', 'Tojoyasz', 'Tojoyata', 'Tojoyatb', 'Tojoyatc', 'Tojoyatd',
      'Tojoyate', 'Tojoyatf', 'Tojoyatg', 'Tojoyath', 'Tojoyati', 'Tojoyatj', 'Tojoyatk', 'Tojoyatl',
      'Tojoyatm', 'Tojoyatn', 'Tojoyato', 'Tojoyatp', 'Tojoyatq', 'Tojoyatr', 'Tojoyats', 'Tojoyatt',
      'Tojoyatu', 'Tojoyatv', 'Tojoyatw', 'Tojoyatx', 'Tojoyaty', 'Tojoyatz', 'Tojoyau', 'Tojoyaua',
      'Tojoyaub', 'Tojoyauc', 'Tojoyaud', 'Tojoyaue', 'Tojoyauf', 'Tojoyaug', 'Tojoyauh', 'Tojoyaui',
      'Tojoyauj', 'Tojoyauk', 'Tojoyaul', 'Tojoyaum', 'Tojoyaun', 'Tojoyauo', 'Tojoyaup', 'Tojoyauq',
      'Tojoyaur', 'Tojoyaus', 'Tojoyaut', 'Tojoyauu', 'Tojoyauv', 'Tojoyauw', 'Tojoyaux', 'Tojoyauy',
      'Tojoyauz', 'Tojoyav', 'Tojoyava', 'Tojoyavb', 'Tojoyavc', 'Tojoyavd', 'Tojoyave', 'Tojoyavf',
      'Tojoyavg', 'Tojoyavh', 'Tojoyavi', 'Tojoyavj', 'Tojoyavk', 'Tojoyavl', 'Tojoyavm', 'Tojoyavn',
      'Tojoyavo', 'Tojoyavp', 'Tojoyavq', 'Tojoyavr', 'Tojoyavs', 'Tojoyavt', 'Tojoyavu', 'Tojoyavv',
      'Tojoyavw', 'Tojoyavx', 'Tojoyavy', 'Tojoyavz', 'Tojoyaw', 'Tojoyawa', 'Tojoyawb', 'Tojoyawc',
      'Tojoyawd', 'Tojoyawe', 'Tojoyawf', 'Tojoyawg', 'Tojoyawh', 'Tojoyawi', 'Tojoyawj', 'Tojoyawk',
      'Tojoyawl', 'Tojoyawm', 'Tojoyawn', 'Tojoyawo', 'Tojoyawp', 'Tojoyawq', 'Tojoyawr', 'Tojoyaws',
      'Tojoyawt', 'Tojoyawu', 'Tojoyawv', 'Tojoyaww', 'Tojoyawx', 'Tojoyawy', 'Tojoyawz', 'Tojoyax',
      'Tojoyaxa', 'Tojoyaxb', 'Tojoyaxc', 'Tojoyaxd', 'Tojoyaxe', 'Tojoyaxf', 'Tojoyaxg', 'Tojoyaxh',
      'Tojoyaxi', 'Tojoyaxj', 'Tojoyaxk', 'Tojoyaxl', 'Tojoyaxm', 'Tojoyaxn', 'Tojoyaxo', 'Tojoyaxp',
      'Tojoyaxq', 'Tojoyaxr', 'Tojoyaxs', 'Tojoyaxt', 'Tojoyaxu', 'Tojoyaxv', 'Tojoyaxw', 'Tojoyaxx',
      'Tojoyaxy', 'Tojoyaxz', 'Tojoyay', 'Tojoyaya', 'Tojoyayb', 'Tojoyayc', 'Tojoyday', 'Tojoyaye',
      'Tojoyayf', 'Tojoyayg', 'Tojoyayh', 'Tojoyayi', 'Tojoyayj', 'Tojoyyay', 'Tojoyayl', 'Tojoyaym',
      'Tojoayn', 'Tojoayo', 'Tojoayp', 'Tojoyayq', 'Tojoyayr', 'Tojoyays', 'Tojoayt', 'Tojoyayu',
      'Tojoyayv', 'Tojoyayw', 'Tojoyayx', 'Tojoyayy', 'Tojoyayz'
    ]
  },
  'Pakistan': {
    code: 'PK',
    states: [
      'Azad Kashmir', 'Balochistan', 'Excised Areas', 'Federally Administered Tribal Areas', 'Federal Capital Territory',
      'Gilgit-Baltistan', 'Islamabad Capital Territory', 'Khyber Pakhtunkhwa', 'Punjab', 'Sindh'
    ]
  },
  'Bangladesh': {
    code: 'BD',
    states: [
      'Barishal', 'Barisal', 'Chattogram', 'Dhaka', 'Khulna', 'Mymensingh', 'Rajshahi', 'Rangpur', 'Sylhet'
    ]
  },
  'Argentina': {
    code: 'AR',
    states: [
      'Buenos Aires', 'Catamarca', 'Chaco', 'Chubut', 'Córdoba', 'Corrientes', 'Distrito Federal',
      'Entre Ríos', 'Formosa', 'Jujuy', 'La Pampa', 'La Rioja', 'Mendoza', 'Misiones', 'Neuquén',
      'Río Negro', 'Salta', 'San Juan', 'San Luis', 'Santa Cruz', 'Santa Fe', 'Santiago del Estero', 'Tierra del Fuego', 'Tucumán'
    ]
  },
  'Chile': {
    code: 'CL',
    states: [
      'Ahuachapán', 'Antofagasta', 'Arauco', 'Atacama', 'Bío-Bío', 'Coyhaique', 'Los Angeles',
      'Los Ríos', 'Los Lagos', 'Magallanes', 'Maule', 'Metropolitan', 'Ñuble', 'O\'Higgins', 'Punta Arenas',
      'Tarapacá', 'Valparaíso'
    ]
  },
  'Colombia': {
    code: 'CO',
    states: [
      'Amazonas', 'Antioquia', 'Arauca', 'Atlántico', 'Bolívar', 'Boyacá', 'Caldas', 'Caquetá', 'Cartagena',
      'Casanare', 'Cauca', 'Cesar', 'Choco', 'Córdoba', 'Cundinamarca', 'Darién', 'Distrito Capital', 'Eje Cafetero',
      'Guainía', 'Guaviare', 'Huila', 'La Guajira', 'Magdalena', 'Meta', 'Nariño', 'Norte de Santander', 'Putumayo',
      'Quindío', 'Risaralda', 'Sabana de Bogotá', 'Santander', 'Sucre', 'Tolima', 'Valle del Cauca', 'Vaupés', 'Vichada'
    ]
  },
  'Peru': {
    code: 'PE',
    states: [
      'Amazonas', 'Ancash', 'Apurímac', 'Arequipa', 'Ayacucho', 'Cajamarca', 'Callao', 'Cusco', 'Huancavelica',
      'Huánuco', 'Ica', 'Junín', 'La Libertad', 'Lambayeque', 'Lima', 'Loreto', 'Madre de Dios', 'Moquegua',
      'Pasco', 'Piura', 'Puno', 'San Martín', 'Tacna', 'Tumbes', 'Ucayali'
    ]
  },
  'Venezuela': {
    code: 'VE',
    states: [
      'Amazonas', 'Anzoátegui', 'Apure', 'Aragua', 'Barinas', 'Bolívar', 'Carabobo', 'Cojedes', 'Delta Amacuro',
      'Dependencias Federales', 'Distrito Federal', 'Falcón', 'Guárico', 'Lara', 'Mérida', 'Miranda', 'Monagas',
      'Nueva Esparta', 'Portuguesa', 'Sucre', 'Táchira', 'Trujillo', 'Vargas', 'Yaracuy', 'Zulia'
    ]
  },
  'Ecuador': {
    code: 'EC',
    states: [
      'Azuay', 'Bolívar', 'Cañar', 'Carchi', 'Chimborazo', 'Cotopaxi', 'Cuenca', 'El Oro', 'Esmeraldas',
      'Galápagos', 'Guayas', 'Imbabura', 'Loja', 'Los Ríos', 'Manabí', 'Morona-Santiago', 'Napo', 'Orellana',
      'Pastaza', 'Pichincha', 'Santa Elena', 'Santo Domingo', 'Sucumbíos', 'Tungurahua', 'Zamora-Chinchipe'
    ]
  },
  'Kenya': {
    code: 'KE',
    states: [
      'Baringo', 'Bomet', 'Bungoma', 'Busia', 'Caliber', 'Central', 'Coast', 'Eastern', 'Embu', 'Garissa',
      'Homa Bay', 'Isiolo', 'Kajiado', 'Kakamega', 'Kamba', 'Kericho', 'Kiambu', 'Kigali', 'Kilifi', 'Kinyaga',
      'Kirinyaga', 'Kisii', 'Kisumu', 'Kitui', 'Konza', 'Kwale', 'Laikipia', 'Lamu', 'Limuru', 'Londiani', 'Makadara',
      'Makallalaka', 'Mandera', 'Marsabit', 'Mbeere', 'Mbita', 'Meru', 'Migori', 'Mina', 'Mobasa', 'Mogotio', 'Mombasa',
      'Monze', 'Mor', 'Morangi', 'Moscha', 'Mount Elgon', 'Mount Kenya', 'Moyale', 'Muhoroni', 'Mukhukunda', 'Mulot', 'Mumbuni',
      'Mumias', 'Murang\'a', 'Muranga', 'Muribai', 'Muruma', 'Mutare', 'Mutukula', 'Mwatate', 'Mwea', 'Mweiga', 'Myogo',
      'Nairobi', 'Nakuru', 'Namagga', 'Namango', 'Namwamba', 'Nandi', 'Nandini', 'Nanduvia', 'Naniruvi', 'Nanyuki', 'Narumoru',
      'Naryn', 'Nawango', 'Ndumberi', 'Nech', 'Nechi', 'Negeri', 'Neginema', 'Neguano', 'Neja', 'Nendeni', 'Nenemu', 'Nengeta',
      'Nengelena', 'Nengeli', 'Nengeta', 'Nengetori', 'Nenica', 'Nenicina', 'Nenicia', 'Nenida', 'Neniel', 'Neniga', 'Nenigia',
      'Nenihira', 'Neniji', 'Nenija', 'Nenijala', 'Nenijapa', 'Nenijir', 'Nenijiri', 'Nenijita', 'Nenijiu', 'Nenijog', 'Nenijoi',
      'Nenijola', 'Nenijong', 'Nenijora', 'Nenijarippa', 'Nenijasya', 'Nenijata', 'Nenijati', 'Nenijato', 'Nenijatu', 'Nenijava',
      'Nenijawa', 'Nenijaya', 'Nenijaza', 'Nenijba', 'Nenijbe', 'Nenijbi', 'Nenijbo', 'Nenijbu', 'Nenijca', 'Nenijce', 'Nenijci',
      'Nenijco', 'Nenijcu', 'Nenijda', 'Nenijde', 'Nenijdi', 'Nenijdo', 'Nenijdu', 'Nenijea', 'Nenijee', 'Nenijei', 'Nenijeo',
      'Nenijeu', 'Nenijfa', 'Nenijfe', 'Nenijfi', 'Nenijfo', 'Nenijfu', 'Nenijga', 'Nenijge', 'Nenijgi', 'Nenijgo', 'Nenijgu',
      'Nenijha', 'Nenijhe', 'Nenijhi', 'Nenijho', 'Nenijhu', 'Nenijia', 'Nenijie', 'Nenijii', 'Nenijio', 'Nenijiu', 'Nenijja',
      'Nenijje', 'Nenijji', 'Nenijjo', 'Nenijju', 'Nenijka', 'Nenijke', 'Nenijki', 'Nenijko', 'Nenijku', 'Nenijla', 'Nenijle',
      'Nenijli', 'Nenijlo', 'Nenijlu', 'Nenijma', 'Nenijme', 'Nenijmi', 'Nenijmo', 'Nenijmu', 'Nenijne', 'Nenijno', 'Nenijnu',
      'Nenijoa', 'Nenijoe', 'Nenijoi', 'Nenijoo', 'Nenijou', 'Nenijpa', 'Nenijpe', 'Nenijpi', 'Nenijpo', 'Nenijpu', 'Nenijqa',
      'Nenijqe', 'Nenijqi', 'Nenijqo', 'Nenijqu', 'Nenijra', 'Nenijre', 'Nenijri', 'Nenijro', 'Nenijru', 'Nenijsa', 'Nenijse',
      'Nenijsi', 'Nenijso', 'Nenijsu', 'Nenijta', 'Nenikte', 'Nenijti', 'Nenijto', 'Nenijtu', 'Nenijua', 'Nenijue', 'Nenijui',
      'Nenijuo', 'Nenijuu', 'Nenijva', 'Nenijve', 'Nenijvi', 'Nenijvo', 'Nenijvu', 'Nenijwa', 'Nenijwe', 'Nenijwi', 'Nenijwo',
      'Nenijwu', 'Nenijxa', 'Nenijxe', 'Nenijxi', 'Nenijxo', 'Nenijxu', 'Nenijya', 'Nenijye', 'Nenijyi', 'Nenijyo', 'Nenijyu',
      'Nenijza', 'Nenijze', 'Nenijzi', 'Nenijzo', 'Nenijzu', 'Nenijka', 'Nenilib', 'Nenikc', 'Nenikd', 'Nenike', 'Nenikf', 'Nenikgo',
      'Nenigg', 'Nenik', 'Nenikhh', 'Neniki', 'Nenikkj', 'Nenikk', 'Neniia', 'Nenilb', 'Nenilc', 'Nenild', 'Nenile', 'Nenilf',
      'Nenilg', 'Nenilh', 'Nenili', 'Nenilj', 'Nenilk', 'Nenill', 'Nenilm', 'Neniln', 'Nenilo', 'Nenilp', 'Nenilq', 'Nenilr',
      'Nenils', 'Nenilt', 'Nenilu', 'Nenilv', 'Nenilw', 'Nenilx', 'Nenily', 'Nenilz', 'Nenima', 'Nenimb', 'Nenimc', 'Nenimd',
      'Nenime', 'Nenimf', 'Nenimg', 'Nenimh', 'Nenimi', 'Nenimj', 'Nenimk', 'Neniml', 'Nenimm', 'Nenimn', 'Nenimo', 'Nenimp',
      'Nenimq', 'Nenimr', 'Nenims', 'Nenimt', 'Nenimu', 'Nenimv', 'Nenimw', 'Nenimx', 'Nenimy', 'Nenimz'
    ]
  }
};

// Get sorted list of all countries
export const ALL_COUNTRIES = Object.keys(COUNTRIES_WITH_STATES).sort();

// Get states for a specific country
export const getStatesForCountry = (country) => {
  const countryData = COUNTRIES_WITH_STATES[country];
  return countryData?.states || [];
};

// Get country code
export const getCountryCode = (country) => {
  const countryData = COUNTRIES_WITH_STATES[country];
  return countryData?.code || '';
};
